<template> 
        <div class="middleBox "> 
            <h4 class="title pb-3 border-bottom text-left mb-4">{{$t('personalInfo')}}</h4>
            <!--loader - message--->
            <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
            <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
            <div class="stepForm row" v-if="info_var == '1'"> 
                <div class="col-12 col-md-4 mobPad">
                    <div class="form-group field-wrapper">
                        <input placeholder=" " type="text" v-model="f_name"  v-validate="'required'" name="First Name" class="float-field form-control" ref="f_nameInput" :class="{ 'is-invalid': submittedRequest && errors.has('First Name') }" :disabled="disable" @focus="trackFzEvent('fName')"/>
                        <label for="password" class="float-label">{{$t('fname')}}<sup class="red">*</sup></label>
                        <p class="error" v-if="submittedRequest" v-for="error in errors.collect('First Name')">{{ error }}</p>  
                    </div>
                </div>
                <div class="col-12 col-md-4 mobPad">
                    <div class="form-group field-wrapper"> 
                        <input placeholder=" " type="text" v-model="l_name" class="float-field form-control" v-validate="'required'" name="Last Name"  :class="{ 'is-invalid': submittedRequest && errors.has('Last Name') }"  :disabled="disable" ref="l_nameInput" @focus="trackFzEvent('lName')"/>
                        <label for="password"  class="float-label">{{$t('lname')}}<sup class="red">*</sup></label>
                        <p class="error" v-if="submittedRequest" v-for="error in errors.collect('Last Name')">{{ error }}</p>  
                    </div>
                </div>
                <div class="col-12 col-md-4 mobPad">
                    <div class="form-group field-wrapper">
                    	<!-- <datepicker 
							v-model="dob" 
							type="date" 
							:editable=true  
							placeholder=" " 
							class="customflaotField mdb-select md-form form-control"   
							name="dob" 
							v-validate="{ required: true , date_format:'YYYY-MM-DD' }" 
							:lang="lang" 
							:class="(dob != '' && dob != 'Invalid Date'?'active' :'') || ({ 'is-invalid': submittedRequest && errors.has('dob') })"   
							:disabled="disable" 
							@blur="checkGreaterAge()" 
							@change="datePickerFunc();checkGreaterAge()"
						/> -->
						<!-- :class="(dob != '' && dob != 'Invalid Date' ? 'active' : '') || {'is-invalid': submittedRequest && errors.has('dob'),}"  -->
						<input 
							class="float-field form-control text-uppercase pr-2 d-block w-100" 
							type="date" 
							placeholder=""
							v-model="dob" 
							name="dob" 
							ref="dobInput"
							v-validate="'required'" 
							:max="maxDate()" 
							:class="{'is-invalid': submittedRequest && errors.has('dob'),}" 
							:disabled="disable" 
							@input="checkGreaterAge()" 
							@change="datePickerFunc();checkGreaterAge()"
							@focus="trackFzEvent('dob')" 
						/> 
						<label for="password" class="float-label">{{$t('dateOfBirth')}}</label>
                        <p class="error" v-if="submittedRequest" v-for="error in errors.collect('dob')">{{$t('dataFieldReq')}}</p>
                        <p class="error" v-if="greaterthan68">{{$t('stepMsz1')}}</p>  
                    </div>
                </div>
                <div class="col-12 col-md-6 mobPad">
                    <div class="form-group field-wrapper">
                        <input placeholder=" " type="text" v-model="address1" class="float-field form-control" v-validate="'required'" name="Address1"  :class="{ 'is-invalid': submittedRequest && errors.has('Address1') }"   :disabled="disable" ref="address1Input" @focus="trackFzEvent('address')"/>
                        <label for="password" class="float-label">{{$t('addressLine1')}}<sup class="red">*</sup></label>
                        <p class="error" v-if="submittedRequest" v-for="error in errors.collect('Address1')">{{ error }}</p>  
                    </div>
                </div>
                <div class="col-12 col-md-6 mobPad">
                    <div class="form-group field-wrapper">
                        <input placeholder=" " type="text" v-model="address2" class="float-field form-control" name="Address2"    :disabled="disable" @focus="trackFzEvent('address')"/>
                        <label for="password" class="float-label">{{$t('addressLine2')}}</label>
                    </div>
                </div>
                <div class="col-12 col-md-6 mobPad">
                    <div class="form-group field-wrapper tabClass selectbox-style" @click="tabActiveFun('1')">
						<!--country_tax_residence_nationality-->
						<v-select :options="residence_country" :reduce="name => name.iso2" label="name" v-model="res_country"  v-validate="'required'" name="res_country"  :class="((tabActive == '1' || res_country != '')?'active' :'') || ({ 'is-invalid': submittedRequest && errors.has('res_country') })" class="customflaotField form-control" disabled ref="countryList"/>
                        <label for="password" class="float-label">{{$t('resCountry')}}<sup class="red">*</sup></label>
                        <p class="error" v-if="submittedRequest" v-for="error in errors.collect('res_country')">{{ error }}</p>  
                        <p class="error" v-if="resConMsz != ''">{{$t(resConMsz)}}</p>
                    </div> 
                </div>
                <div class="col-12 col-md-6 mobPad">
					<div class="form-group field-wrapper">
                        <input placeholder=" " type="text" v-model="city" class="float-field form-control" v-validate="'required'" name="City Or Town"  :class="{ 'is-invalid': submittedRequest && errors.has('City Or Town') }" :disabled="disable" ref="cityInput" @focus="trackFzEvent('city')"/>
                        <label for="password" class="float-label">{{$t('city')}}<sup class="red">*</sup></label>
                        <p class="error" v-if="submittedRequest" v-for="error in errors.collect('City Or Town')">{{ error }}</p>                
                    </div>
                </div>
                <div class="col-12 col-md-6 mobPad">
                    <div class="form-group field-wrapper">
                        <input placeholder=" " type="text" v-model="post_code" class="float-field form-control" v-validate="{ required: true, min: 3, max: 12 }" name="Post Code"  :class="{ 'is-invalid': submittedRequest && errors.has('Post Code') }" ref="post_codeInput"  :disabled="disable" @focus="trackFzEvent('post_code')" />
                        <label for="password" class="float-label">{{$t('postCode')}}<sup class="red">*</sup></label>
                        <p class="error" v-if="submittedRequest" v-for="error in errors.collect('Post Code')">{{ error }}</p>  
                    </div>
                </div>
				<!-- <div class="col-12 col-md-6 mobPad">
                    <div class="form-group field-wrapper tabClass" @click="tabActiveFun('2')">
						<v-select :options="countriesList" :reduce="name => name.iso2" label="name" v-model="tax_res_country"  v-validate="'required'" name="tax_res_country"  :class="((tabActive == '2' || tax_res_country != '')?'active' :'') || ({ 'is-invalid': submittedRequest && errors.has('tax_res_country') })" class="customflaotField form-control" @change="countrySelectFunc()" ref="tax_res_countryInput"/>
                        <label for="password" class="float-label">{{$t('taxResCountry')}}<sup class="red">*</sup></label>
                        <p class="error" v-if="submittedRequest" v-for="error in errors.collect('tax_res_country')">{{ error }}</p>  
                    </div>
                </div> -->
                <div class="col-12 col-md-6 mobPad"> 
                    <div class="form-group field-wrapper tabClass country-selectbox selectbox-style" @click="tabActiveFun('3')">
						<v-select :options="countriesList" :reduce="name => name.iso2" label="name" v-model="res_nationality"  v-validate="'required'" name="Country of Nationality"  :class="((tabActive == '3' || res_nationality != '')?'active' :'') || ({ 'is-invalid': submittedRequest && errors.has('Country of Nationality') })" class="customflaotField form-control"  placeholder="" @change="countrySelectFunc()" ref="res_nationalityInput"/>
						<label for="password" class="float-label">{{$t('nationality')}}<sup class="red">*</sup></label>
                        <p class="error" v-if="submittedRequest" v-for="error in errors.collect('Country of Nationality')">{{ error }}</p>
                    </div>
                </div> 
				<div class="col-12 col-md-6 mobPad">
                    <!-- <div class="form-group field-wrapper">
                        <input placeholder="" type="number" v-model="mobile_no" class="float-field form-control" v-validate="'required'" name="mobile_no"  :class="{ 'is-invalid': submittedRequest && errors.has('mobile_no') }" ref="moble_Input"  :disabled="disable"/>
                        <label for="mobile" class="float-label">{{$t('mobileno')}}<sup class="red">*</sup></label>
                        <p class="error" v-if="submittedRequest" v-for="error in errors.collect('mobile_no')">{{ error }}</p>  
                    </div> -->
					<!-- {{res_country}} -->
					<div class="form-group field-wrapper country-code-field">
						<vue-phone-number-input
							v-model="mobile_no"
							:no-example="true"
							:default-country-code="res_country"
							v-validate="{ required: true, min: 8, max: 15 }"
							ref="mobile_numberInput"
							:class="{
								'is-invalid': submittedRequest && errors.has('Phone Number'),
							}"
							name="Phone Number"
							@update="updatedText"
							@phone-number-focused="handlePhoneNumberFocused"
						/>
						<p class="error" v-for="error in errors.collect('Phone Number')">
							<span
								v-show="
								submittedRequest &&
								error == 'The Phone Number field is required.'">
								The Phone number is required.
							</span>
							<span
								v-show="
								error == 'The Phone Number field must be at least 8 characters.'">
								The Phone Number field must have atleast 8 characters.
							</span>
							<span
								v-show="
								error ==
								'The Phone Number field may not be greater than 15 characters.'
								">
								The Phone number field may not be greater than 15 characters.
							</span>
						</p>
					</div>
                </div>
                <div class="col-12 mobPad">
                    <div class="step-bottom-alert"> 
                        <span><svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="custom-class feather feather-alert-circle"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12" y2="16"></line></svg></span>
                        <p>{{$t('addFieldNote')}}</p>
                    </div>
                </div>
				<div class="col-12 mobPad">
                    <div class="full-width border-top pt-3 submitButton align-items-center d-flex justify-content-end mt-3 w-100">
                        <button class="prism_btn btn_sm" v-on:click="next()">{{$t('Next')}}</button>
                    </div>
                </div>
			</div>
			<div class="stepForm row" v-else> 
                <div class="col-12 col-md-6 mobPad">
					<div class="row">
                        <div class="col-6">
                            <p class="mb-3 f-15">{{$t('selectGender')}}<sup class="red">*</sup></p>
							<div class="form-group slctGender field-wrapper"> 
                                <div class=" d-flex align-items-center">
                                    <label class="customRadio-button mb-0" for="password">{{$t('male')}} <sup class="red"></sup>
                                        <input type="radio" v-model="gender" class="form-control"  v-validate="'required'" name="Gender"  :class="{ 'is-invalid': submitted && errors.has('Gender') }" ref="genderInput" value="M"  :disabled="disable" @focus="trackFzEvent('male')"/> 
                                        <span class="checkmark"></span>
                                    </label> 
                                    <label class=" ml-3 mb-0 customRadio-button" for="password">{{$t('female')}} <sup class="red"></sup>
                                        <input type="radio" v-model="gender" class="float-field form-control"  v-validate="'required'" name="Gender"  :class="{ 'is-invalid': submitted && errors.has('Gender') }" ref="genderInput" value="F"  :disabled="disable" @focus="trackFzEvent('female')"/>
                                        <span class="checkmark"></span>
                                    </label>   
                                </div>
                                <p class="error" v-if="errors.first('Gender')">{{$t('genderField')}}</p> 
							</div>
						</div>
					</div>
				</div>
				<div class="col-12 mobPad" v-if="!id_dri_var">
					<div class="row">
                        <div class="col-12 col-md-6">
							<div class="form-group field-wrapper">
								<input placeholder=" " type="text" v-model="pass_num" class="float-field form-control"  v-validate="'required'" name="Passport Number"  :class="{ 'is-invalid': submitted && errors.has('Passport Number') }" ref="pass_numInput"  :disabled="disable" @focus="trackFzEvent('passport')"/>
								
                                <label for="password" class="float-label" v-if="parseInt(other_id) == 0">{{$t('passportNumber')}}<sup class="red">*</sup></label> 
                                <label for="password" class="float-label" v-else-if="parseInt(other_id) == 1">{{$t('idNumber')}}<sup class="red">*</sup></label> 
                                <!-- <label for="password" class="float-label" v-else-if="parseInt(other_id) == 2">{{$t('drivLicNum')}}<sup class="red">*</sup></label>  -->
                                <label for="password" class="float-label" v-else>{{$t('passportNumber')}}<sup class="red">*</sup></label>                         
                                <p class="error" v-if="submitted" v-for="error in errors.collect('Passport Number')">{{ error }}</p> 
							</div>
						</div>
                        <div class="col-12 col-md-6">
                            <small class="donthavepassport" v-if="parseInt(other_id) == 0">{{$t('dontPassport')}} <a href="#" @click="id_dri_var = true ; pass_num = ''; mifir= '' ; crs = ''; other_id = null">{{$t('clickHere')}}</a></small>
                            <small class="donthavepassport" v-else-if="parseInt(other_id) == 1">{{$t('idNumber')}} <a href="#" @click="id_dri_var = true ; pass_num = ''; mifir= '' ; crs = ''; other_id = null">{{$t('clickHere')}}</a></small>
                            <!-- <small class="donthavepassport" v-else-if="parseInt(other_id) == 2">{{$t('drivLicNum')}} <a href="#" @click="id_dri_var = true ; pass_num = ''; mifir= '' ; crs = ''">{{$t('clickHere')}}</a></small>  -->
                            <small class="donthavepassport" v-else>{{$t('dontPassport')}} <a href="#" @click="id_dri_var = true ; pass_num = ''; mifir= '' ; crs = ''; other_id = null">{{$t('clickHere')}}</a></small>
                        </div>
					</div>
				</div>
				<div class="col-12 mb-3 d-flex align-items-center mobPad" v-if="id_dri_var">
					<span class="idn"> {{$t('selIdntProof')}}</span>
                </div>
				<div class="col-12 d-flex align-items-center radioWrap mobPad" v-if="id_dri_var">
					<div class="form-group mb-0 mr-3" @click="showMifirQuestion=0"> 
                        <label class="customRadio-button">
                            <input type="radio" class="form-control" name="other_id" v-model="other_id" value="0" :disabled="disable">
                            <span class="checkmark"></span>
                            {{$t('passportNumber')}}
                        </label>
                    </div>
                    <div class="form-group mb-0 mr-3" @click="showMifirQuestion=0"> 
						<label class="customRadio-button">
							<input type="radio" class="form-control" name="other_id" v-model="other_id" value="1" :disabled="disable">
							<span class="checkmark"></span>
							{{$t('idNumber')}}
						</label>
					</div>
					<!-- <div class="form-group  mb-0" @click="showMifirQuestion=0"> 
						<label class="customRadio-button">
							<input type="radio" class="form-control" name="other_id" v-model="other_id" value="2" :disabled="disable">
							<span class="checkmark"></span>
							{{$t('drivLicNum')}}
						</label>
					</div> -->
				</div>
                <div class="col-12 col-md-12 mobPad" v-if="other_id == '0' && id_dri_var">
                    <div class="form-group field-wrapper mb-0">
                        <input placeholder=" " type="text" v-model="pass_num" class="float-field form-control" v-validate="'required'" name="Passport Number"  :class="{ 'is-invalid': submitted && errors.has('Passport Number') }" ref="pass_numInput"  :disabled="disable" @focus="trackFzEvent('passport')"/>
                        <label for="password" class="float-label">{{$t('enterPassNum')}}<sup class="red">*</sup></label>  
                    </div>
                </div>
				<div class="col-12 col-md-12 mobPad" v-if="other_id == '1' && id_dri_var">
					<div class="form-group field-wrapper mb-0">
						<input placeholder=" " type="text" v-model="pass_num" class="float-field form-control" v-validate="'required'" name="Passport Number"  :class="{ 'is-invalid': submitted && errors.has('Passport Number') }" ref="pass_numInput" :disabled="disable" @focus="trackFzEvent('passport')"/>
						<label for="password" class="float-label">{{$t('enterIdenNum')}}<sup class="red">*</sup></label>  
					</div>
				</div>
				<!-- <div class="col-12 col-md-12 mobPad" v-if="other_id == '2' && id_dri_var">
					<div class="form-group field-wrapper">
						<input placeholder=" " type="text" v-model="pass_num" class="float-field form-control"  v-validate="'required'" name="pass_num"  :class="{ 'is-invalid': submitted && errors.has('pass_num') }" ref="pass_numInput" :disabled="disable"/>
						<label for="password" class="float-label">{{$t('enterDrivLicNum')}}<sup class="red">*</sup></label>  
					</div>
				</div> -->
                <div class="col-12 col-md-12 mobPad" v-if="submitted && errors.first('Passport Number') && id_dri_var">
                    <div class="form-group field-wrapper">
                        <p class="error" >{{$t('fieldReq1')}}</p>
                    </div>
                </div>
                <!-----------------crs and mifir code start---------------------------------------------------------------->
                <!-- <div class="col-12 col-md-6 mobPad" v-if="tax_res_country != '' && tax_res_country != null">
                    <div class="row d-flex align-items-center">
						<div class="col-12 col-md-12" v-if="conJson[tax_res_country] && conJson[tax_res_country].CRS.name != 'N/A'">
                            <div class="form-group field-wrapper mb-2">
                                <input placeholder=" " type="text" v-model="crs" class="float-field form-control" name="crs" :class="{ 'is-invalid': submitted && errors.has('crs') }" ref="crsInput"  :disabled="disable" v-validate="'required'" />
                                <label for="password" class="float-label">{{conJson[tax_res_country].CRS.name}}<sup class="red">*</sup></label> 
								<p class="error" v-if="submitted" v-for="error in errors.collect('crs')">{{ crs_msz }}</p> 								
                            </div>
                        </div> 
					</div>	
				</div>  -->
                <div class="col-12 col-md-12 mobPad" v-if="tax_res_country != ''">
                    <div class="row d-flex align-items-center">
                        <div class="col-12 col-md-12" >
							<div class="form-group field-wrapper mb-2" v-if="checkIfMifir()">
								<!---{ required: req_var , regex : regex_var  }-->
								<input placeholder=" " type="text" v-model="mifir" class="float-field form-control" v-validate="{ required: req_var, regex : regex_var}" name="mifir"  :class="{ 'is-invalid': submitted && errors.has('mifir') }" ref="mifirInput" :disabled="disable"/>
								<label for="password" class="float-label">{{mifirfieldname}}<sup class="red">*</sup></label>
								<p class="donthavepassport" v-if="parseInt(nonconcatcountries.indexOf(res_nationality)) == -1">Don't have a {{mifirfieldname}} <a href="#" @click="showNextQues()">Click Here</a></p>
								<p class="error" v-if="submitted" v-for="error in errors.collect('mifir')">{{ regex_msz }}</p>
							</div>
                        </div>
                    </div>
                </div>
<!--------------------pep and us person-------------------------------------------------------------------->
				<div class="col-12 col-md-11 mobPad">
                    <div class="form-group field-wrapper mb-2 mt-0 custom-control custom-switch">  
                        <input type="checkbox" class="custom-control-input" id="pep" v-model="pep" :disabled="disable" @focus="trackFzEvent('pep')"> 
                        <label class="custom-control-label"  :class="(pep)?'bold-yes':'bold-no'">{{$t('pep')}} 
						<span class="yesno" for="pep">
						</span>
                            <div class="tooltip">?
                                <span class="tooltiptext">
                                    <span class="inscroll scrollbar" v-html="$t('stepMsz2')"> </span>
                                </span>
                            </div>
                        </label> 
                    </div>
                    <!-- <div class="form-group field-wrapper mb-1 mt-2 custom-control custom-switch">  
						<input type="checkbox" class="custom-control-input" id="us_person" v-model="us_person" :disabled="disable"> 
						<label class="custom-control-label" for="us_person" :class="(us_person)?'bold-yes':'bold-no'">{{$t('usPerson')}} <span class="yesno"></span>
							<div class="tooltip">?
								<span class="tooltiptext">
									<span class="inscroll scrollbar" v-html="$t('stepMsz3')"></span>  
								</span>
							</div>
						</label> 
                    </div>  -->
                </div>
				<div class="col-12 mobPad mb-3">
					<h6 class="subtitle mb-2 d-flex align-items-center justify-content-between justify-content-md-start"> <span class="sameColor">Are you a US tax reportable person ? <sup class="red">*</sup></span>
						<!-- <a href="#" class="ml-2" data-toggle="tooltip" data-placement="top"  data-html="true" title="
							<div class='cstm-tooltip'>
								<p>The definition of a U.S. tax reportable person includes:</p>
									<ol type='I'>
										<li>A U.S. citizen or resident (including dual citizenship),</li>
										<li>A U.S. alien (resident for tax purposes)</li>
										<li>A person born in the U.S?</li>
										<li>A person with a current U.S. mailing or residence address (including a U.S. post office box or U.S. in care of address)</li>
										<li>A person with a current U.S. telephone number</li>
										<li>A person with standing instructions to transfer funds to an account maintained in the United Sates?</li>
										<li>A person with current and effective power of attorney or signatory authority granted to a person with U.S. address?</li>
										<li>A person who hold a US immigrant visa (“Green Card”)</li>
									</ol>  
								<p>You will find further information on the internet at this address: <a href='http://www.irs.gov/Businesses/Corporations/Foreign-Account-Tax-Compliance-Act-FATCA'>http://www.irs.gov/Businesses/Corporations/Foreign-Account-Tax-Compliance-Act-FATCA</a></p>
							</div>
						">
							<feather type="alert-circle"></feather>
						</a> -->
						
						<a href="#" class="ml-2 tooltip">!
							<div class='tooltiptext reportable'>
								<span class="inscroll scrollbar">
									<p>The definition of a U.S. tax reportable person includes:</p>
								<ol type='I'>
									<li>A U.S. citizen or resident (including dual citizenship),</li>
									<li>A U.S. alien (resident for tax purposes)</li>
									<li>A person born in the U.S?</li>
									<li>A person with a current U.S. mailing or residence address (including a U.S. post office box or U.S. in care of address)</li>
									<li>A person with a current U.S. telephone number</li>
									<li>A person with standing instructions to transfer funds to an account maintained in the United Sates?</li>
									<li>A person with current and effective power of attorney or signatory authority granted to a person with U.S. address?</li>
									<li>A person who hold a US immigrant visa (“Green Card”)</li>
								</ol>  
								<p>You will find further information on the internet at this address: <a href='http://www.irs.gov/Businesses/Corporations/Foreign-Account-Tax-Compliance-Act-FATCA' target="_blank">http://www.irs.gov/Businesses/Corporations/Foreign-Account-Tax-Compliance-Act-FATCA</a></p>
							</span>
							</div>
							<!-- <feather type="alert-circle"></feather> -->
						</a>
						
					</h6>
					<div class="d-flex align-items-center mb-2">
						<label class="customRadio-button  m-0 mr-2">Yes
							<input 
								type="radio" 
								class="form-control" 
								:value="1" 
								v-model="usFatca" 
								v-validate="'required'"
								name="USFatca" 
								:class="{ 'is-invalid': submitted && errors.has('USFatca') }"
								@focus="trackFzEvent('usTax')"
							>
							<span class="checkmark"></span>
						</label>
						<label class="customRadio-button m-0 ml-3">No
							<input 
								type="radio" 
								class="form-control" 
								:value="0" 
								v-model="usFatca" 
								v-validate="'required'" 
								name="USFatca"
								:class="{ 'is-invalid': submitted && errors.has('USFatca') }"
								@focus="trackFzEvent('usTax')"
							>
							<span class="checkmark"></span>
						</label>
					</div>
					<p class="error" v-if="errors.first('USFatca')">{{ errors.first('USFatca') }}</p>
					<div class="mb-2 mt-3" id="selectOption" v-if="usFatca === 0">
						<div class="form-group field-wrapper mb-2 tabClass" v-on:click.prevent="tabActiveFun('4')">
							<v-select 
								:clearable="false" 
								:options="residence_country" 
								:reduce="(name) => name.iso2" 
								label="name" 
								v-model="tax_res_country" 
								v-validate="'required'" 
								name="Tax Residence Country" 
								:class="
									(tabActive == '4' || residence_country != ''
									? 'active'
									: '') || {
									'is-invalid':
										submittedRequest && errors.has('residence_country'),
									}
								"
								class="customflaotField form-control"
							/>
							<label class="float-label">Country of Tax Residence<sup class="red">*</sup>
							</label>
							<p class="error" v-for="error in errors.collect('Tax Residence Country')"> {{ error }} </p>
						</div>
						<label class="d-block mb-2">Do you have TIN Number? <span class="text-danger">*</span></label>
						<div class="d-flex align-items-center mb-2">
							<label class="customRadio-button  m-0 mr-2">Yes
								<input 
									type="radio" 
									class="form-control" 
									value="1" 
									v-model="is_crs" 
									v-validate="'required'" 
									name="TIN Number" 
									:class="{ 'is-invalid': submitted && errors.has('TIN Number') }"
									@focus="trackFzEvent('TIN')"									
								>
								<span class="checkmark"></span>
							</label>
							<label class="customRadio-button m-0">No
								<input 
									type="radio" 
									class="form-control" 
									value="0" 
									v-model="is_crs" 
									v-validate="'required'" 
									name="TIN Number" 
									:class="{ 'is-invalid': submitted && errors.has('TIN Number') }"
									@focus="trackFzEvent('TIN')"
								>
								<span class="checkmark"></span>
							</label>
						</div>
						<p class="error" v-if="submittedRequest && errors.has('TIN Number')">
							{{ errors.first('TIN Number') }}
						</p>
					</div>
					<div class="form-group field-wrapper mb-2 mt-3 tabClass" v-if="is_crs == 0 && usFatca == 0">
						<div class="form-group field-wrapper m-0 tabClass" v-on:click.prevent="tabActiveFun('5')">
							<select
								class="customflaotField form-control"
								v-model="jurisdiction_tax_residence"
								v-validate="'required'"
								name="Reason"
								:class="(tabActive == '5' || jurisdiction_tax_residence != '' ? 'active' : '') || {'is-invalid': submitted && errors.has('Reason'),}"
								:disabled="disable"
							>
								<option v-for="(value, key) in jurisdiction_tax_residence_list" :value="key">
									{{ value }}
								</option>
							</select>
							<label class="float-label">If no TIN available enter reason <sup class="red">*</sup></label>
							<p class="error" v-for="error in errors.collect('Reason')"> {{ error }} </p>
						</div>
					</div>
					<div class="form-group field-wrapper mb-2 mt-3 tabClass" v-if="jurisdiction_tax_residence == 2 && usFatca == 0 && is_crs == 0">
						<label class="float-labels">Enter reason<sup class="red">*</sup></label>
						<textarea
							type="text"
							v-model="crs_reason"
							v-validate="'required'" 
							:class="{ 'is-invalid': submittedRequest && errors.has('Reason') }" 
							:disabled="disable"
							class="float-field form-control"
							name="Reason"
							>
						</textarea>
						<p class="error" v-if="errors.first('Reason')">{{ errors.first('Reason') }}</p>
					</div>
					<div class="form-group field-wrapper mb-2 mt-3 tabClass" v-if="is_crs == 1 && usFatca == 0">
						<input
							type="text"
							v-model="crs"
							v-validate="'required'" 
							:class="{ 'is-invalid': submittedRequest && errors.has('TIN') }" 
							:disabled="disable"
							class="float-field form-control"
							name="TIN"
						/>
						<label class="float-label">Enter TIN number<sup class="red">*</sup></label>
						<p class="error" v-if="errors.first('TIN')">{{ errors.first('TIN') }}</p>
					</div>
				</div>
                <div class="col-12 col-md-12 mobPad mt-4">
                    <div class="step-bottom-alert"> 
                        <span><svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="custom-class feather feather-alert-circle"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12" y2="16"></line></svg></span>
                        <p>{{$t('regkindlyEnsureId')}}</p>
                    </div>
                </div> 
                

                <div class="col-12 mobPad">
                    <div class="full-width border-top pt-3 submitButton align-items-center d-flex spacebetween mt-3 w-100"> 
                        <a href="#"  v-on:click="backStepEvent" >{{$t('back')}}</a>  
                        <div>
                            <a class="mr-3" href="#"  v-on:click="doitLaterEvent" >{{$t('iDoLater')}}</a>
                            <button class="prism_btn btn_sm" v-on:click="submit()" :class="(!continueButton)? 'disabled' :''">{{$t('saveContinue')}}</button>
                        </div> 
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
	import Datepicker from 'vue2-datepicker';
	//	import 'vue2-datepicker/index.css';
    import * as types from '@/types'
    import { mapActions } from 'vuex'
    import { fxViewMixins } from '@/plugins/fxView'
    import { Const }  from '@/plugins/fxView/provider/candle-history/lib/const.cls'
    //import Datepicker from 'vuejs-datepicker';
    import moment from 'moment'
    let dOfBirth = this.dob	
    export default {
        name: 'stepOne',
        mixins: [fxViewMixins],
        data() {
            return {
				residence_country : [],
				continueButton : true,
				resConMsz : '',
				info_var : '1',
				submittedRequest : false,
				crs_req_var : false,
				crs_regex_var : '',
				crs_msz : '',
				req_var : false,
				regex_var : '',
				regex_msz : '',
				id_dri_var : false,
				other_id : 0,
				id_number : '',
				driving_number : '',
                conJson : { },
				response_msg : '',
                msg_type : '',
                pageLoader : false,
                "f_name" : '',
                "m_name" : '',
                "l_name" : '',
                "res_country" : '',
                "res_nationality" : '',
                "address1" : '',
                "address2" : '',
				"mobile_no" : '',
				mobile_number: "",
                numberWithCountry:'',
                numberValid:false,
                "post_code" : '',
                "city" : '',
                "pep" : false,
                "us_person" : false,
                "step" : 1,
                selectRadio : '',
                pass_num: '',
				mifir : '',
                mifir_type : "",
                mifirfieldname:'',
				showMifirQuestion : 0,
                tax_res_country: '',
                greaterthan68: false,
                dob: '',
				gender : '',
                disable: false,
                disabledDates :{
                    from : new Date().setDate(new Date().getDate() - 18250),
                    to : new Date().setDate(new Date().getDate() - 4850)
                },
				lang: {
					formatLocale: {
						firstDayOfWeek: 1,
					},
					monthBeforeYear: false,
				},
                nonconcatcountries: ['EE','ES','IS','IT', 'MT', 'PL'],
				tabActive : '',
                default_country: "",
                us_person: false,

				usFatca: "",
				is_crs: null,
				crs: '',
				crs_reason: '',
				jurisdiction_tax_residence: '',
				submitted: false,
            }
        },   
        watch: {
			tax_res_country: function (val) {
				if(this.tax_res_country == 'US'){
					this.us_person = true
				}
			},
			res_nationality: function (val) {
				if(this.res_nationality == 'US'){
					this.us_person = true
				}
			}
		},
		computed:{
            userProfile(){
                return this.$store.getters[Const.GET_USER_PROFILE]
            }
        },
        methods:{
            updatedText(e) {
                this.numberWithCountry = e.formattedNumber;
                this.numberValid = e.isValid;
            },
			maxDate() {
				return moment().format("YYYY-MM-DD");
			},
            checkGreaterAge(){
                if(this.dob){
                    const dateB = moment(); 
                    const dateC = moment(this.dob,'YYYY-MM-DD') //.format('YYYY-MM-DD'); 
                    const age = dateB.diff(dateC, 'years', true);
                    if(age < 18){
                         this.greaterthan68 = true
                    }else{
                        this.greaterthan68 = false
                    }
                }
            },
			RemoveNode(iso2){
				return this.countriesList.filter(function(emp) {
					if (emp.iso2 == iso2) {
						return false;
					}
					return true;
				});
			},
			tabActiveFun(getData){
				this.tabActive = getData
			},
			next(){
				this.$trackEvent('CP+Client+Verification+1+Next');
				this.$trackEvent('CP+Client+Verification+2+Pageview');
				const _that = this
				this.submittedRequest = true;
                this.$validator.validate().then(valid => {
                    if (valid) {
						const dateB = moment(); 
                        const dateC = moment(_that.dob).format('YYYY-MM-DD'); 
                        const age = dateB.diff(dateC, 'years');
                        console.log('age--',age)
                        if(age < 18){
                             _that.greaterthan68 = true
                        } 
						// else if(age > 68){
                        //     _that.greaterthan68 = true
                        // }
						else{
							_that.info_var = '2'
                            // this.countrySelectFunc()
							_that.countrySelectFunc()
						}
					}else{
						_that.handleValidationErrorAdvanced(_that.errors)
					}
                });
			},
			countrySelectFunc(){
				this.showMifirQuestion = 0
				// this.checkIfMifir()
			},
			showNextQues(){
				this.showMifirQuestion = parseInt(this.showMifirQuestion) +1
				//this.checkIfMifir() //add 
			},
            radomGenerateForMifir(){
				this.mifir = Math.floor(100000 + Math.random() * 900000) //rndom number
			},
            closeModalFunc(){
                this.$parent.$parent.showStepComponent = false
            },
            customFormatter(date) {
                return moment(date).format('DD-MM-YYYY');
            },
			trackFzEvent(eventName){
				switch(eventName){
					case 'fName': 
						this.$trackEvent('CP+Client+Verification+1+Name');
					break;
					case 'lName':
						this.$trackEvent('CP+Client+Verification+1+Second+Name');
					break;
					case 'dob':
						this.$trackEvent('CP+Client+Verification+1+DOB');
					break;
					case 'address':
						this.$trackEvent('CP+Client+Verification+1+Address');
					break;
					case 'city':
						this.$trackEvent('CP+Client+Verification+1+Town');
					break;
					case 'post_code':
						this.$trackEvent('CP+Client+Verification+1+Postal+Code');
					break;
					case 'male':
						this.$trackEvent('CP+Client+Verification+2+Gender');
					break;
					case 'female':
						this.$trackEvent('CP+Client+Verification+2+Gender');
					break;
					case 'passport':
						this.$trackEvent('CP+Client+Verification+2+Passport+Focus');
					break;
					case 'pep':
						this.$trackEvent('CP+Client+Verification+2+PEP');
					break;
					case 'usTax':
						this.$trackEvent('CP+Client+Verification+2+US+TAX');
					break;
					case 'TIN':
						this.$trackEvent('CP+Client+Verification+2+TIN');
					break;
				}
			},
			handlePhoneNumberFocused(){
                this.$trackEvent('CP+Client+Verification+1+Phone');
            },
			doitLaterEvent(){
				this.$trackEvent('CP+Client+Verification+2+Later');
				this.$parent.do_later = true
			},
			backStepEvent(){
				this.info_var = '1';
				this.$trackEvent('CP+Client+Verification+2+Back');
			},
            checkIfMifir(){
                // Here are conditions
                // if CRS and mifir are same  don't show mifir code fill same as CRS
                // else if user selected passport number and nationality has passport as mifir option don't show mifir
                // else if user donesn't selected passport number and nationality has passport as mifir option don't show mifir
                // else if user doesn't selectd passport number show mifir
                if(this.other_id == ''){
                    this.showMifirQuestion = 0
                }

                if(this.showMifirQuestion > 0){
                    if(this.conJson[this.res_nationality] && this.conJson[this.res_nationality].MIFIR[this.showMifirQuestion] == undefined){
                        this.conJson[this.res_nationality].MIFIR[this.showMifirQuestion] = {
                            "name": "CONCAT",
                            "validation": {'important': false, 'regex' : ''}
                        }
                    }
                }
				if(this.res_nationality){
                    // console.log(this.showMifirQuestion,this.res_nationality,'--------------------',this.conJson[this.res_nationality])
                    if(this.res_nationality!= '' && this.res_nationality != null && this.conJson[this.res_nationality] && this.conJson[this.res_nationality].MIFIR[this.showMifirQuestion].validation != ''){
                        this.req_var = this.conJson[this.res_nationality].MIFIR[this.showMifirQuestion].validation.important,
                        this.regex_var = this.conJson[this.res_nationality].MIFIR[this.showMifirQuestion].validation.regex
                       // this.regex_msz = this.conJson[this.res_nationality].MIFIR[this.showMifirQuestion].validation.msz
                        this.regex_msz = "Invalid "+this.mifirfieldname
                    }
                    if(this.tax_res_country!= '' && this.tax_res_country != null && this.conJson[this.tax_res_country] && this.conJson[this.tax_res_country].CRS.validation != ''){
                        this.crs_req_var = this.conJson[this.tax_res_country].CRS.validation.important,
                        this.crs_regex_var = this.conJson[this.tax_res_country].CRS.validation.regex
                        //this.crs_msz = this.conJson[this.tax_res_country].CRS.validation.msz
                        this.crs_msz = "Invalid "+this.conJson[this.tax_res_country].CRS.name
                    }

                    if(this.res_nationality!= '' && this.res_nationality != null &&  this.conJson[this.res_nationality] &&  this.conJson[this.res_nationality].MIFIR[this.showMifirQuestion].name  == 'CONCAT'){
                        let firstname = this.f_name.substr(0, 5)
                        let fnamechararray  = firstname.split("")
                        if(fnamechararray.length != 5){
                            let len = fnamechararray.length
                            for (var i = len; i < 5; i++) {
                                fnamechararray[i] = "#"
                            }
                            firstname = fnamechararray.join("")
                        }

                        let lastname = this.l_name.substr(0, 5)
                        let lnamechararray  = lastname.split("")
                        if(lnamechararray.length != 5){
                            let len = lnamechararray.length
                            for (var i = len; i < 5; i++) {
                                lnamechararray[i] = "#"
                            }
                            lastname = lnamechararray.join("")
                        }
                        let concatedValue = moment(this.dob).format('YYYYMMDD')+firstname.toUpperCase()+lastname.toUpperCase()
                        this.mifir  = concatedValue
                        this.mifir_type = "CONCAT"

                        return false
                    }
                    else if(this.res_nationality!= '' && this.res_nationality != null &&  this.conJson[this.res_nationality] &&  this.conJson[this.res_nationality].MIFIR[this.showMifirQuestion].name  == 'National Passport Number' && parseInt(this.other_id) == 0){
                        //mifir will be concat
                        // console.log("return from National passport")
                        this.mifir  = this.pass_num
                        this.mifir_type = "CCPT"
                        return false
                    }
                    else if(this.res_nationality!= '' && this.res_nationality != null &&  this.conJson[this.res_nationality] &&  this.conJson[this.res_nationality].MIFIR[this.showMifirQuestion].name  == 'National Passport Number' && parseInt(this.other_id) !== 0){
                        //mifir will be concat
                        // console.log("return from National passport not selected")
                        this.showMifirQuestion = this.showMifirQuestion+1
                        this.checkIfMifir()
                        // return false
                    }
                    else if(this.tax_res_country != '' && this.res_nationality != '' && this.tax_res_country != null && this.res_nationality != null && this.conJson[this.tax_res_country] && this.conJson[this.tax_res_country].CRS.name == this.conJson[this.res_nationality].MIFIR[this.showMifirQuestion].name && this.tax_res_country == this.res_nationality){
                        //mifir will be concat
                        // console.log("return from mifir and crs is same")
                        this.mifir  = this.crs
                        this.mifir_type = "NIDN"
                        return false
                    }
                    else{ 
						// console.log("return from else")
                        // console.log(this.res_nationality)
                        this.mifirfieldname = this.conJson[this.res_nationality].MIFIR[this.showMifirQuestion].name 
                        this.mifir_type = "NIDN"
                        return true
                    }
                }else{
                    return false
                }
            },
            ...mapActions({
                _runRegisterStepOne: types.RUN_REGISTER_STEP1
            }),
            handleClose() {
                const input = this.$refs.dobInput.$children[0];
                input.typedDate = false;
            },
            submit(){
				
                if(this.disable){
                    let currentStep = this.get_user.step
                    if('tempStep' in this.get_user && currentStep < this.get_user.tempStep){
                        currentStep = this.get_user.tempStep
                    }
                    this.get_user.tempStep = currentStep
                    this.get_user.step = 1          
                    let user_json = this.get_user
                    this.$store.commit(types.SET_STATE, user_json)

                }else{
                    const _that = this
                    this.submitted = true;
                    this.$validator.validate().then(valid => {
                        if (valid) {
                            let input_json={
                                'globalParams' :{
                                    fname : _that.f_name ,
                                    mname : _that.m_name ,
                                    lname : _that.l_name ,
                                    dob   : moment(_that.dob).format('YYYY-MM-DD'),
                                    address1 : _that.address1 ,
                                    address2 : _that.address2,
                                    residence_country : _that.res_country,
                                    nationality : _that.res_nationality,
                                    post_code : _that.post_code,
                                    city : _that.city,
                                    pep : _that.pep,
                                    us_person : _that.us_person,
                                    corr_address1 : _that.address1,
                                    corr_address2 : _that.address2,
                                    corr_post_code : _that.post_code,
                                    corr_city : _that.city,
                                    step : _that.step,
                                    crs : _that.crs,
                                    mifir: _that.mifir,
                                    mifir_type: _that.mifir_type,
                                    idproof: _that.other_id,
                                    p_id : _that.pass_num,
                                    gender : _that.gender,
                                    res_tax: _that.tax_res_country,
									mobile_no: _that.numberWithCountry,
                                    // mobile_no: _that.mobile_number,
									usFatca: parseInt(_that.usFatca),
									is_crs: parseInt(_that.is_crs),
									crs: (_that.is_crs==1?_that.crs:''),
									crs_reason: (_that.is_crs == 0)?(this.jurisdiction_tax_residence != 2 ? this.jurisdiction_tax_residence_list[this.jurisdiction_tax_residence]:_that.crs_reason):_that.crs,
                                },
                                'localParams' :{ "parameter" : _that }
                            } 
							// console.log(_that.is_crs,this.jurisdiction_tax_residence_list,this.jurisdiction_tax_residence)
							// console.log(input_json.globalParams)
							this.$trackEvent('CP+Client+Verification+2+Next')
                            _that._runRegisterStepOne(input_json)
                        }else{
                            _that.handleValidationErrorAdvanced(_that.errors)
                        }
                    }); 
                }
                
            },
			
			datePickerFunc(){
                // console.log()
				this.conJson = {
					"UY": {
					"country": "Uruguay ",
					"CRS": {
					"name": "Single Register of Tax Payers Number (RUT) OR ID card",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"US": {
					"country": "United States",
					"CRS": {
					"name": "Social Security Number (SSN) OR Employer Identification Number (EIN) OR Individual Taxpayer Identification Number (ITIN)",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"GB": {
					"country": "United Kingdom ",
					"CRS": {
					"name": "National Insurance Number (NINO).",
					"validation": {'important': true , 'regex' : /^[ABCEGHJKLMNOPRSTWXYZ][ABCEGHJKLMNPRSTWXYZ][\d]{6}[A-D]$/, 'msz' : "The format of the number is two prefix letters, six digits and one suffix letter.An example is QQ123456C.. Neither of the first two letters can be D, F, I, Q, U or V. The second letter also cannot be O , the six digits and  The suffix letter is either A, B, C, or D" }
                    },
					"MIFIR": [
					{
					"name": "National Insurance Number (NINO).",
					"validation": {'important': true , 'regex' : /^[ABCEGHJKLMNOPRSTWXYZ][ABCEGHJKLMNPRSTWXYZ][\d]{6}[A-D]$/, 'msz' : "The format of the number is two prefix letters, six digits and one suffix letter.An example is QQ123456C.. Neither of the first two letters can be D, F, I, Q, U or V. The second letter also cannot be O , the six digits and  The suffix letter is either A, B, C, or D" }
					},
					{
					"name": "CONCAT",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"AE": {
					"country": "United Arab Emirates ",
					"CRS": {
					"name": "N/A",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"TC": {
					"country": "Turks and Caicos Islands ",
					"CRS": {
					"name": "N/A",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"TR": {
					"country": "Turkey ",
					"CRS": {
					"name": "National Identity Number ",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"TT": {
					"country": "Trinidad and Tobago ",
					"CRS": {
					"name": "BIR number",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"BS": {
					"country": "The Bahamas ",
					"CRS": {
					"name": "N/A",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"CH": {
					"country": "Switzerland ",
					"CRS": {
					"name": "UID-number",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					},
					{
					"name": "CONCAT",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"SE": {
					"country": "Sweden",
					"CRS": {
					"name": "Personal identity number/personnummer",
					"validation": {'important': true , 'regex' : new RegExp('^' + moment(this.dob).format('YYMMDD') + '-[0-9]{4,6}$') , 'msz' : "10 or 12 digits and a hyphen. First 6 digits date of birth in format(YYMMDD),then hypen to separate out digits from date of birth 4-6digit number following your date of birth in the format: YYMMDD-XXXX."}
					},
					"MIFIR": [
					{
					"name": "Personal identity number/personnummer",
					"validation": {'important': true , 'regex' : new RegExp('^' + moment(this.dob).format('YYMMDD') + '-[0-9]{4,6}$') , 'msz' : "10 or 12 digits and a hyphen. First 6 digits date of birth in format(YYMMDD),then hypen to separate out digits from date of birth 4-6digit number following your date of birth in the format: YYMMDD-XXXX."}
					}
					]
					},
					"ES": {
					"country": "Spain",
					"CRS": {
					"name": "Numero de Identificacion Fiscal",
					"validation": {'important': true , 'regex' : /^[\d]{8}[ABCDEFGHJKLMNPQRSTVWXYZ]$/ , 'msz' : "9 digit number: 8 numbers and a control letter. Letters I,O and U are not used"}
					},
					"MIFIR": [
					{
    					"name": "Numero de Identificacion Fiscal",
    					"validation": {'important': true , 'regex' : /^[\d]{8}[ABCDEFGHJKLMNPQRSTVWXYZ]$/ , 'msz' : "9 digit number: 8 numbers and a control letter. Letters I,O and U are not used"}
    					}
					]
					},
					"ZA": {
					"country": "South Africa",
					"CRS": {
					"name": "Taxpayer reference number",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"SI": {
					"country": "Slovenia ",
					"CRS": {
					"name": "SI tax number",
					"validation": {'important': true , 'regex' : /^[1-9]{1}[\d]{7}$/ , 'msz' : "random 8 digit number. The first digit cannot be 0."}
					},
					"MIFIR": [
					{
					"name": "Personal Identification Number (EM_O: Enotna Mati_na _tevilka Ob_ana)",
					"validation": {'important': false , 'regex' : new RegExp('^' + moment(this.dob).format('YYMMDD') + '[0-9]{4}[0-1][8-9][0-9]$') , 'msz' : "13 digits.It is defined as YYMMDDSSSSCAZ:YYMMDD represents the date of birth (DoB);SSSS is a sequence number registered with the birth date (where females are assigned sequential numbers starting with 0 to 4 and males from 5 to 9)C is the citizenship with 0 if the person is a SA citizen, 1 if the person is a permanent resident;A is 8 or 9. Prior to 1994 this number was used to indicate the holder's race;Z is a checksum digit."}
					},
					{
					"name": "CONCAT",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"SK": {
					"country": "Slovak Republic ",
					"CRS": {
					"name": "Personal number (Rodn slo)",
					"validation": {'important': true , 'regex' : new RegExp('^' + moment(this.dob).format('YYMMDD') + '[0-9]{4}$') , 'msz' : "10 digits in the form YYMMDDCCCX"}
					},
					"MIFIR": [
					{
					"name": "Personal number (Rodn slo)",
					"validation": {'important': false , 'regex' : new RegExp('^' + moment(this.dob).format('YYMMDD') + '[0-9]{4}$') , 'msz' : "10 digits in the form YYMMDDCCCX"}
					},
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"SG": {
					"country": "Singapore ",
					"CRS": {
					"name": "NRIC Number OR FIN",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"SC": {
					"country": "Seychelles ",
					"CRS": {
					"name": "Tax Identification Number",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"SA": {
					"country": "Saudi Arabia ",
					"CRS": {
					"name": "Tax Identification Number",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"SM": {
					"country": "San Marino ",
					"CRS": {
					"name": "Social Security Number (SSI Number)",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"WS": {
					"country": "Samoa ",
					"CRS": {
					"name": "Tax Payer Identification Number",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"VC": {
					"country": "Saint Vincent and the Grenadines ",
					"CRS": {
					"name": "Tax Identification Number",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"LC": {
					"country": "Saint Lucia ",
					"CRS": {
					"name": "TIN",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"RU": {
					"country": "Russian Federation ",
					"CRS": {
					"name": "Taxpayer Personal Identification Number (INN)",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"RO": {
					"country": "Romania ",
					"CRS": {
					"name": "National Identification Number (Cod Numeric Personal)",
					"validation": {'important': true , 'regex' : new RegExp('^[0-9]' + moment(this.dob).format('YYMMDD') + '[0-9]{2}(00[1-9]|0[1-9][0-9]|1[0-9][0-9]|2[0-9][0-9]|3[0-9][0-9]|4[0-9][0-9]|5[0-9][0-9]|6[0-9][0-9]|7[0-9][0-9]|8[0-9][0-9]|9[0-9][0-9])[0-9]$') , 'msz' : "The CNP consist of 13 digits as follows:1 digit for the sex of the Person. 1=Male & 2=Female born before 2005, 3 & 4 before 1899, 5 & 6 before 2099, 7 & 8 for foreign residents[10] 6 digits for Date of birth YYMMDD 2 digits represents the place of birth (County) next 3 digits is a number between 001 and 999. Each number is allocated only once per person per day last digit is a control digit."}
					},
					"MIFIR": [
					{
					"name": "National Identification Number (Cod Numeric Personal)",
					"validation": {'important': true , 'regex' : new RegExp('^[0-9]' + moment(this.dob).format('YYMMDD') + '[0-9]{2}(00[1-9]|0[1-9][0-9]|1[0-9][0-9]|2[0-9][0-9]|3[0-9][0-9]|4[0-9][0-9]|5[0-9][0-9]|6[0-9][0-9]|7[0-9][0-9]|8[0-9][0-9]|9[0-9][0-9])[0-9]$') , 'msz' : "The CNP consist of 13 digits as follows:1 digit for the sex of the Person. 1=Male & 2=Female born before 2005, 3 & 4 before 1899, 5 & 6 before 2099, 7 & 8 for foreign residents[10] 6 digits for Date of birth YYMMDD 2 digits represents the place of birth (County) next 3 digits is a number between 001 and 999. Each number is allocated only once per person per day last digit is a control digit."}
					},
					{
					   "name": "National Passport Number",
					   "validation": {'important': true , 'regex' : new RegExp('^[0-9]{13}$') , 'msz' : "13 digits"}
					}
					]
					},
					"PT": {
					"country": "Portugal ",
					"CRS": {
					"name": "Tax number (Nmero de Identificao Fiscal)",
					"validation": {'important': true , 'regex' : new RegExp('^[0-9]{9}$') , 'msz' : "9 digits"}
					},
					"MIFIR": [
					{
					"name": "Tax number (Nmero de Identificao Fiscal)",
					"validation": {'important': false , 'regex' : new RegExp('^[0-9]{9}$') , 'msz' : "9 digits"}
					},
					{
					"name": "National Passport Number",
					"validation": ''
					}
					]
					},
					"PL": {
					"country": "Poland",
					"CRS": {
					"name": "National Identification Number (PESEL)",
					"validation": {'important': true , 'regex' : new RegExp('^' + moment(this.dob).format('YYMMDD') + '[0-9]{4}[0-9]$') , 'msz' : "11 NUMERIC. PESEL number has the form of YYMMDDZZZXQ, where YYMMDD is the date of birth (with century encoded in month field), ZZZX is the personal identification number, where X codes sex (even number for females, odd number for males) and Q is a check digit, which is used to verify whether a given PESEL is correct or not"}
					},
					"MIFIR": [
					{
					"name": "National Identification Number (PESEL)",
					"validation": {'important': false , 'regex' : new RegExp('^' + moment(this.dob).format('YYMMDD') + '[0-9]{4}[0-9]$') , 'msz' : "PESEL number has the form of YYMMDDZZZXQ, where YYMMDD is the date of birth (with century encoded in month field), ZZZX is the personal identification number, where X codes sex (even number for females, odd number for males) and Q is a check digit, which is used to verify whether a given PESEL is correct or not"}
					},
					{
					"name": "Tax Number (Numer identyfikacji podatkowej)",
					"validation": {'important': true , 'regex' : new RegExp('^' + moment(this.dob).format('YYMMDD') + '[0-9]{4}[0-9]$') , 'msz' : "11 NUMERIC. ID for natural persons is assigned to a person shortly after birth by the birth registry and does not change throughout the life of a person."}
					}
					]
					},
					"NO": {
					"country": "Norway",
					"CRS": {
					"name": "Identity Number or D-Number",
					"validation": {'important': true , 'regex' : new RegExp('^' + moment(this.dob).format('DDMMYY') + '[0-9]{5}$') , 'msz' : "The id is 11 digits long, where the first 6 represent birthdate in ddmmyy format."}
					},
					"MIFIR": [
					{
					"name": "Identity Number or D-Number",
					"validation": {'important': false , 'regex' : new RegExp('^' + moment(this.dob).format('DDMMYY') + '[0-9]{5}$') , 'msz' : "The id is 11 digits long, where the first 6 represent birthdate in ddmmyy format."}
					},
					{
					"name": "CONCAT",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"NZ": {
					"country": "New Zealand ",
					"CRS": {
					"name": "IRD Number",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"AN": {
					"country": "Netherland",
					"CRS": {
					"name": "TIN",
					"validation": {'important': false, 'regex' : new RegExp('^[0-9]{8}[0-9]$') ,'msz':'9 digits: Validation rule and check digid:1. The TIN always has 9 digits: N1, N2, N3, N4, N5, N6, N7, N8, N9N9 is a check digit.2. Algorithm for check digit:((N1*9) + (N2*8) + (N3*7) + (N4*6) + (N5*5) + (N6*4) + (N7*3) + (N8*2)) modulo 11 Check digit (N9) = remainder from above algorithmIf remainder = 10, the TIN is not valid.'}

					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : new RegExp('^[ABCDEPGHIJKLMNPQRRSTUVWXYZ]{2}[0-9ABCDEPGHIJKLMNPQRRSTUVWXYZ]{6}[0-9]$') , 'msz' : '9 characters of which: Position 1 and 2: [A-Z] except for "O"; Position 3 - 8: [A-Z] [0-9] except for "O"; Position 9: [0-9].'}
					},
					{
					"name": "National identity card number",
					"validation":{'important': false, 'regex' : new RegExp('^[ABCDEPGHIJKLMNPQRRSTUVWXYZ]{2}[0-9ABCDEPGHIJKLMNPQRRSTUVWXYZ]{6}[0-9]$') , 'msz' : '9 characters of which: Position 1 and 2: [A-Z] except for "O"; Position 3 - 8: [A-Z] [0-9] except for "O"; Position 9: [0-9].'}
					}
					]
					},
					"NR": {
					"country": "Nauru",
					"CRS": {
					"name": "Nauru Integrated Tax System / NITS",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"MS": {
					"country": "Montserrat",
					"CRS": {
					"name": "N/A",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"MX": {
					"country": "Mexico",
					"CRS": {
					"name": "Clave en el Registro Federal de Contribuyentes / RFC",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"MU": {
					"country": "Mauritius",
					"CRS": {
					"name": "Tax Account Number",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"MH": {
					"country": "Marshall Islands",
					"CRS": {
					"name": "Employer/e Identification Number OR Social Security Number",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"MT": {
					"country": "Malta",
					"CRS": {
					"name": "National Identification Number",
					"validation": {'important': true , 'regex' : new RegExp('^[0-9]{7}[(MGAPLHBZ)]{1}$') , 'msz' : "8 digits,- 7 digits and 1 letter (M, G, A, P, L, H, B, Z)"}
					},
					"MIFIR": [
					{
					"name": "National Identification Number",
					"validation": {'important': true , 'regex' : new RegExp('^[0-9]{7}[(MGAPLHBZ)]{1}$') , 'msz' : "8 digits,- 7 digits and 1 letter (M, G, A, P, L, H, B, Z)"}
					},
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"MY": {
					"country": "Malaysia",
					"CRS": {
					"name": "Income tax Number/Nombor Cukai Pendapatan",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"MO": {
					"country": "Macao",
					"CRS": {
					"name": "ID Number",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"LU": {
					"country": "Luxembourg",
					"CRS": {
					"name": "National identification Number (TIN-like)",
					"validation": {'important': false, 'regex' : new RegExp('^[0-9]{11,13}$'),'msz' : "1) Structure and syntax of Luxembourg TIN-like numbers for non-natural persons: The identifier has 11 digits (99999999999), the last digit is a check digit.The 11th digit corresponds to the difference between 11 and the remainder of the division by 11 of thesum of the products obtained by multiplying each of the first 10 digits of the ID number by therespective factors of 5, 4, 3, 2, 7, 6, 5, 4, 3 and 2, being understood that of the numbers generated,during the abovementioned division, a remainder of 1 is not allocated. A remainder of zero during that division is the check digit.2) Structure and syntax of Luxembourg TIN-like numbers for natural persons : The identification number has 13 digits (9999999999999), the 2 last digits are check digits."}
					},
					"MIFIR": [
					{
					"name": "CONCAT",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"LT": {
					"country": "Lithuania",
					"CRS": {
					"name": "Personal code (Asmens kodas)",
					"validation": {'important': true , 'regex' : new RegExp('^[3-6]'+ moment(this.dob).format('YYMMDD')+'[0-9]{3}[0-9]$') , 'msz' : "It is 11 digits long. Format GYYMMDDNNNC, where G is the gender (4 or 6 for women; 3 or 5 for men); YYMMDD is the date of birth; NNN - serial number; C - check digit."} 
					},
					"MIFIR": [
					{
					"name": "Personal code (Asmens kodas)",
					"validation": {'important': false , 'regex' : new RegExp('^[3-6]'+ moment(this.dob).format('YYMMDD')+'[0-9]{3}[0-9]$') , 'msz' : "It is 11 digits long. Format GYYMMDDNNNC, where G is the gender (4 or 6 for women; 3 or 5 for men); YYMMDD is the date of birth; NNN - serial number; C - check digit."} 
					},
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"LI": {
					"country": "Liechtenstein",
					"CRS": {
					"name": "Personenidentifikationsnummer (PEID Nummer)",
					"validation": {'important': true , 'regex' : new RegExp('^[0-9]{1,12}$') , 'msz' : "Up to 12 digits and consists exclusively of numerals: The first digits might be omitted if they correspond to the numeral zero"}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false , 'regex' : new RegExp('^[A-Z][0-9]{5}$') , 'msz' : "6 digits: 1 letter and 5 numbers"}
					},
					{
					"name": "National Identity Card Number",
					"validation": {'important': true , 'regex' : new RegExp('^[A-Z]{2}[0-9]{8}$') , 'msz' : "10 digits: 2 letters and 8 numbers"}
					}
					]
					},
					"LB": {
					"country": "Lebanon ",
					"CRS": {
					"name": "TIN",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"LV": {
					"country": "Latvia ",
					"CRS": {
					"name": "Personal code (Personas kods)",
					"validation": {'important': true , 'regex' : new RegExp('^'+ moment(this.dob).format('DDMMYY')+'[-]{0,1}[012][0-9]{4}$') , 'msz' : "11 numerical digits of the form DDMMYY-CZZZZ where the first 6 are the date of birth (DDMMYY) and the C is century sign (where the digit 0 is the 19th century, the number 1 - the 20th century, 2 - 21th century)."}
					},
					"MIFIR": [
					{
					"name": "Personal code (Personas kods)",
					"validation": {'important': true , 'regex' : new RegExp('^'+ moment(this.dob).format('DDMMYY')+'[-]{0,1}[012][0-9]{4}$') , 'msz' : "11 numerical digits of the form DDMMYY-CZZZZ where the first 6 are the date of birth (DDMMYY) and the C is century sign (where the digit 0 is the 19th century, the number 1 - the 20th century, 2 - 21th century)."}
					
					},
					{
					"name": "CONCAT",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"KW": {
					"country": "Kuwait ",
					"CRS": {
					"name": "Civil Identification Number",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"KR": {
					"country": "Korea ",
					"CRS": {
					"name": "Resident Registration Number",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"JE": {
					"country": "Jersey ",
					"CRS": {
					"name": "Social Security Number",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"JP": {
					"country": "Japan ",
					"CRS": {
					"name": "Individual Number",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"IT": {
					"country": "Italy",
					"CRS": {
						"name": "Fiscal code (Codice fiscale)",
						"validation": {'important': true, 'regex' : new RegExp('^[A-Z]{3}[A-Z]{3}'+ moment(this.dob).format('YY')+'[ABCDEHLMPRST][0-9]{2}[A-Z][0-9]{3}[A-Z]$'),'msz' : "the fiscal code is made of 16 alphanumeric characters and different for legal and natural  persons . 1) Legal Persons : (e.g. corporations) it comprises 11 numeric-only characters. While it is possible to calculate one's tax code, the only official tax code is the one provided by the tax office, which avoids cases of identical tax codes (which is a frequent case for people not born in Italy, as in this case the 4-characters town code in the codice fiscale is replaced by 'Z' followed by a 3-digit country code) as well as cases where a code is incorrect, but still valid (because provided by the tax office).2) Natural  Persons : Surname -- the first three consonants of the surname are used. If there is more than one surname, both are considered as if they were one. If the surname has less than three consonants, then vowels will replace the blank spaces, in the same order they appear in the surname (e.g. 'Rossi' would be RSS, 'Masi' would be MSA). If the whole surname has less than three letters, the blank spaces are replaced with an X (e.g. 'Fo' would be FOX, 'Hu' would be HUX). The surname used is always the name that appears in the person's primary identification document: for native Italians. First name  --- (3 letters) the first three consonants of the name are used. If there is more than one name, both are considered as if they were one. If the name has less than three consonants, then vowels will replace the blank spaces, in the same order they appear in the name (e.g. Marco would be MRC, Paola would be PLA). If the whole name has less than three letters, the blank spaces are filled with an X (e.g. Chinese name Na would be NAX). Some Indian immigrants in Italy are registered with a triple X instead of their first name, since their passport only indicates a single word which is used as a surname by the Italian register office. If the name has more than three consonants, the 2nd is skipped (e.g. Riccardo would be RCR; Martina would be MTN). This second-consonant skipping rule for names that have more than three consonants is only used for first names, not for surnames.Then date of Birth (YY numericCharacter DD).Then Town of birth (4 alphanumeric characters) example People born in a foreign country have their own code according to the country of birth, all of them beginning with letter Z (e.g. United States code is Z404, the UK code is Z114, Australia is Z700, etc.) and Check character (one letter)"}
					},
					"MIFIR": [
					{
					"name": "Fiscal code (Codice fiscale)",
					"validation": {'important': true, 'regex' : new RegExp('^[A-Z]{3}[A-Z]{3}'+ moment(this.dob).format('YY')+'[ABCDEHLMPRST][0-9]{2}[A-Z][0-9]{3}[A-Z]$'),'msz' : "the fiscal code is made of 16 alphanumeric characters and different for legal and natural  persons . 1) Legal Persons : (e.g. corporations) it comprises 11 numeric-only characters. While it is possible to calculate one's tax code, the only official tax code is the one provided by the tax office, which avoids cases of identical tax codes (which is a frequent case for people not born in Italy, as in this case the 4-characters town code in the codice fiscale is replaced by 'Z' followed by a 3-digit country code) as well as cases where a code is incorrect, but still valid (because provided by the tax office).2) Natural  Persons : Surname -- the first three consonants of the surname are used. If there is more than one surname, both are considered as if they were one. If the surname has less than three consonants, then vowels will replace the blank spaces, in the same order they appear in the surname (e.g. 'Rossi' would be RSS, 'Masi' would be MSA). If the whole surname has less than three letters, the blank spaces are replaced with an X (e.g. 'Fo' would be FOX, 'Hu' would be HUX). The surname used is always the name that appears in the person's primary identification document: for native Italians. First name  --- (3 letters) the first three consonants of the name are used. If there is more than one name, both are considered as if they were one. If the name has less than three consonants, then vowels will replace the blank spaces, in the same order they appear in the name (e.g. Marco would be MRC, Paola would be PLA). If the whole name has less than three letters, the blank spaces are filled with an X (e.g. Chinese name Na would be NAX). Some Indian immigrants in Italy are registered with a triple X instead of their first name, since their passport only indicates a single word which is used as a surname by the Italian register office. If the name has more than three consonants, the 2nd is skipped (e.g. Riccardo would be RCR; Martina would be MTN). This second-consonant skipping rule for names that have more than three consonants is only used for first names, not for surnames.Then date of Birth (YY numericCharacter DD).Then Town of birth (4 alphanumeric characters) example People born in a foreign country have their own code according to the country of birth, all of them beginning with letter Z (e.g. United States code is Z404, the UK code is Z114, Australia is Z700, etc.) and Check character (one letter)"}
					}
					]
					},
					"IL": {
					"country": "Israel ",
					"CRS": {
					"name": "ID Number",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"IM": {
					"country": "Isle of Man ",
					"CRS": {
					"name": "Tax Reference Numbers",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"IE": {
					"country": "Ireland",
					"CRS": {
					"name": "Personal Public Service Number (PPS No)",
					"validation": {'important': true , 'regex' : new RegExp('^[0-9]{7}[A-Z]{1,2}$') , 'msz' : "7 digits+either 1 or 2 letters, The format of the PPS number was defined as being nine characters in length, consisting of 7 digits in positions 1 to 7, followed by a check character in position 8 and 9 position consist of any alphabetic character"}
					},
					"MIFIR": [
					{
					"name": "CONCAT",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"ID": {
					"country": "Indonesia ",
					"CRS": {
    					"name": "Nomor Pokok Wajib Pajak (NPWP)",
    					"validation": {'important': false, 'regex' : ''}
    					},
					"MIFIR": [
    					{
    					"name": "National Passport Number",
    					"validation": {'important': false, 'regex' : ''}
    					}
					]
					},
					"IN": {
					"country": "India ",
					"CRS": {
    					"name": "PAN",
    					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
    					{
        					"name": "National Passport Number",
        					"validation": {'important': false, 'regex' : ''}
    					},
                        {
                            "name": "CONCAT",
                            "validation": {'important': false, 'regex' : ''}
                        }
					]
					},
					"IS": {
					"country": "Iceland",
					"CRS": {
					"name": "Icelandic Identification Number (kennitala)",
					"validation": {'important': true , 'regex' : new RegExp('^'+ moment(this.dob).format('DDMMYY')+'[-]{0,1}([2-9][0-9])[0-9]{2}$') , 'msz' : "ID numbers are composed of ten digits. For a personal ID number, the first six of these are the individual's date of birth in the format DDMMYY.The seventh and eighth digits are randomly chosen when the ID number is allocated, ranging from 20 to 99. The ninth is a check digit, and the tenth indicates the century of the individual's birth: '9' for 1900–1999, '0' for 2000–2099.ID numbers are often written with a hyphen following the first six digits, e.g. 120174-3399"}
					},
					"MIFIR": [
					{
					   "name": "Icelandic Identification Number (kennitala)",
					   "validation": {'important': true , 'regex' : new RegExp('^'+ moment(this.dob).format('DDMMYY')+'[-]{0,1}([2-9][0-9])[0-9]{2}$') , 'msz' : "ID numbers are composed of ten digits. For a personal ID number, the first six of these are the individual's date of birth in the format DDMMYY.The seventh and eighth digits are randomly chosen when the ID number is allocated, ranging from 20 to 99. The ninth is a check digit, and the tenth indicates the century of the individual's birth: '9' for 1900–1999, '0' for 2000–2099.ID numbers are often written with a hyphen following the first six digits, e.g. 120174-3399"}
					}
					]
					},
					"HU": {
					"country": "Hungary",
					"CRS": {
					"name": "Adoazonosto Jel",


					"validation": {'important': true , 'regex' : new RegExp('^8'+ moment(this.dob).format('DDMMYY')+'[0-9]{3}[0-9]$') , 'msz' : "10 digits: digit 1 is always 8, digits 2-6 are the number of days between the date 01/01/1867 and the date of birth of the individual(DDMMYY), digits 7-9 is the number generated by chance and digit 10 is the check digit."}
					},
					"MIFIR": [
					{
					"name": "CONCAT",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"HK": {
					"country": "Hong Kong",
					"CRS": {
					"name": "Hong Kong Identity Card (HKID) number",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"GG": {
					"country": "Guernsey ",
					"CRS": {
					"name": "Social Insurance number",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"GL": {
					"country": "Greenland ",
					"CRS": {
					"name": "CPR number",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"GR": {
					"country": "Greece ",
					"CRS": {
					"name": "TIN Number",
					"validation": {'important': true , 'regex' : new RegExp('^[0-9]{9}$') , 'msz' : "9 digits"}
					},
					"MIFIR": [
					{
					"name": "10 DSS digit investor share",
					"validation": {'important': false , 'regex' : new RegExp('^[0-9]{10}$') , 'msz' : "10 digits and it is linked with the personal details of the investor(name,identity number,passport number,TIN)"}
					},
					{
					"name": "CONCAT",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"GI": {
					"country": "Gibraltar ",
					"CRS": {
					"name": "N/A",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"DE": {
					"country": "Germany ",
					"CRS": {
					"name": "Steueridentifikationsnummer",
					"validation": {'important': true , 'regex' : new RegExp('^[0-9]{2}[/]{0,1}[0-9]{3}[/]{0,1}[0-9]{3}[/]{0,1}[0-9]{3}$') , 'msz' : "It's a 10 or 11 digit number, and has the format '12/345/67890'"}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"GE": {
					"country": "Georgia ",
					"CRS": {
					"name": "National Identification Number",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"FR": {
					"country": "France",
					"CRS": {
					"name": "Numero Fiscal de Reference",
					"validation": {'important': true , 'regex' : new RegExp('^[0-9]{13}$') , 'msz' : "13 numerical digits: 99 99 999 999 999"}
					},
					"MIFIR": [
					{
					"name": "CONCAT",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"FI": {
					"country": "Finland",
					"CRS": {
					"name": "Personal identity number",
					"validation": {'important': true , 'regex' : new RegExp('^'+ moment(this.dob).format('DDMMYY')+'[-A][0-9A-Z]{4}$') , 'msz' : "11 digit number DDMMYYCZZZQ .The first six characters correspond to the date of birth(DDMMYY).Following the date of birth there is a hyphen (it might be also an 'A') that separates the remaining four characters, which can be all numbers or include letters. It is these last four characters that differentiate a person's identification code from those of others born on the same date. So, typical identity codes could be 230181-2374 or 230181-237J"}
					},
					"MIFIR": [
					{
					"name": "Personal identity number",
					"validation": {'important': true , 'regex' : new RegExp('^'+ moment(this.dob).format('DDMMYY')+'[-A][0-9A-Z]{4}$') , 'msz' : "11 digit number DDMMYYCZZZQ .The first six characters correspond to the date of birth(DDMMYY).Following the date of birth there is a hyphen (it might be also an 'A') that separates the remaining four characters, which can be all numbers or include letters. It is these last four characters that differentiate a person's identification code from those of others born on the same date. So, typical identity codes could be 230181-2374 or 230181-237J"}
					},
					{
					"name": "CONCAT",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"FO": {
					"country": "Faroe Islands ",
					"CRS": {
					"name": "Faroese P Number",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"EE": {
					"country": "Estonia ",
					"CRS": {
					"name": "Estonian Personal Identification Code(Isikukood)",
					"validation": {'important': true , 'regex' : new RegExp('^[1-6]'+ moment(this.dob).format('YYMMDD')+'[0-9]{4}$') , 'msz' : "An Estonian personal identification code consists of 11 digits, generally given without any whitespace or other delimiters. The form is GYYMMDDSSSC, where G shows sex and century of birth (odd number male, even number female, 1-2 19th century, 3-4 20th century, 5-6 21st century), YY is the year of birth, MM is the month of birth and DD is the date of birth, SSS is a serial number separating persons born on the same date and C a checksum."}
					},
					"MIFIR": [
					{
					"name": "Estonian Personal Identification Code(Isikukood)",
					"validation": {'important': true , 'regex' : new RegExp('^[1-6]'+ moment(this.dob).format('YYMMDD')+'[0-9]{4}$') , 'msz' : "An Estonian personal identification code consists of 11 digits, generally given without any whitespace or other delimiters. The form is GYYMMDDSSSC, where G shows sex and century of birth (odd number male, even number female, 1-2 19th century, 3-4 20th century, 5-6 21st century), YY is the year of birth, MM is the month of birth and DD is the date of birth, SSS is a serial number separating persons born on the same date and C a checksum."}
					}
					]
					},
					"EC": {
					"country": "Ecuador ",
					"CRS": {
					"name": "Numero de Identificacion Fiscal (NIF)",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"DK": {
						"country": "Denmark ",
						"CRS": {
							"name": "CPR number",
							"validation": {'important': true , 'regex' : new RegExp('^'+ moment(this.dob).format('DDMMYY')+'[-]{0,1}[0-9]{4}$') , 'msz' : "Your CPR number consists of ten digits. The first six digits are your date of birth(DDMMYY), and the last four are your unique identification number. The last digit of your CPR number indicates your sex. If it is an odd digit you are male, and if it is an even digit you are female. For example, if your CPR number is 220550-6218, you were born on 22 May 1950 and you are female."}
						},
						"MIFIR": [
							{
								"name": "\"Personal identity code 10 digits alphanumerical DDMMYYXXXX\"",
								"validation": {'important': true , 'regex' : new RegExp('^'+ moment(this.dob).format('DDMMYY')+'[-]{0,1}[0-9]{4}$') , 'msz' : "Your CPR number consists of ten digits. The first six digits are your date of birth(DDMMYY), and the last four are your unique identification number. The last digit of your CPR number indicates your sex. If it is an odd digit you are male, and if it is an even digit you are female. For example, if your CPR number is 220550-6218, you were born on 22 May 1950 and you are female."}
							},
							{
								"name": "CONCAT",
								"validation": {'important': false, 'regex' : ''}
							}
						]
					},
					"CZ": {
						"country": "Czech Republic ",
						"CRS": {
							"name": "National identification number(Rodn slo)",
							"validation": {'important': false, 'regex' : ''}
							//"validation": "for individuals with birthday before 01.01.1954 (9 digits) and since this date (10 digits)"
						},
						"MIFIR": [
							{
								"name": "National identification number(Rodn slo)",
								"validation": {'important': false, 'regex' : ''}
								//"validation": "for individuals with birthday before 01.01.1954 (9 digits) and since this date (10 digits)"
							},
							{
								"name": "National Passport Number",
								"validation": {'important': false, 'regex' : ''}
								//"validation": "for individuals with birthday before 01.01.1954 (9 digits) and since this date (10 digits)"
							}
						]
					},
					"CY": {
						"country": "Cyprus ",
						"CRS": {
							"name": "TIN",
							"validation": {'important': true , 'regex' : new RegExp('^[0-9]{8}[A-Z]$') , 'msz' : "99999999L. 8 digits and 1 letter, where the frst digit is always 0 for individuals."}
						},
						"MIFIR": [
							{
								"name": "National Passport Number",
								"validation": {'important': false , 'regex' : new RegExp('^[A-Z][0-9]{6,8}$') , 'msz' : "One letter followed by 6-8 digits with no spaces or delimiters"}
							},
							{
								"name": "CONCAT",
								"validation": {'important': false, 'regex' : ''}
							}
						]
					},
					"CW": {
					"country": "Cura�ao ",
					"CRS": {
					"name": "Persoonsnummer",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"HR": {
						"country": "Croatia",
						"CRS": {
							"name": "Personal Identification Number(OIB Osobni identifikacijski broj)",
							"validation": {'important': true , 'regex' : new RegExp('^[0-9]{11}$') , 'msz' : "OIB consists of 11 digits. 10 digits are chosen randomly and do not contain information related to the holder of OIB. One digit is a control number. OIB is unique, unchangeable and unrepeatable. It is a permanent identification code of every Croatian citizen and legal person with head office in the Republic of Croatia."}
						},
						"MIFIR": [
							{
								"name": "Personal Identification Number(OIB Osobni identifikacijski broj)",
								"validation": {'important': false , 'regex' : new RegExp('^[0-9]{11}$') , 'msz' : "OIB consists of 11 digits. 10 digits are chosen randomly and do not contain information related to the holder of OIB. One digit is a control number. OIB is unique, unchangeable and unrepeatable. It is a permanent identification code of every Croatian citizen and legal person with head office in the Republic of Croatia."}
							},
							{
								"name": "CONCAT",
								"validation": {'important': false, 'regex' : ''}
							}
						]
					},
					"CR": {
					"country": "Costa Rica ",
					"CRS": {
					"name": "Numero de Indetificacion Tributario Especial (NITE)",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"CK": {
					"country": "Cook Islands ",
					"CRS": {
					"name": "N/A",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"CO": {
					"country": "Colombia ",
					"CRS": {
					"name": "N.I.T ",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"CN": {
					"country": "China ",
					"CRS": {
					"name": "ID Number",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"CL": {
					"country": "Chile ",
					"CRS": {
					"name": "National Identity Number (RUN)",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"KY": {
					"country": "Cayman Islands",
					"CRS": {
					"name": "N/A",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"CA": {
					"country": "Canada ",
					"CRS": {
					"name": "Social Insurance Number (SIN)",
					"validation": {'important': false, 'regex' : ''}
					},
					"MIFIR": [
					{
					"name": "National Passport Number",
					"validation": {'important': false, 'regex' : ''}
					}
					]
					},
					"BG": {
						"country": "Bulgaria ",
						"CRS": {
							"name": "Personal Number",
							"validation": {'important': true , 'regex' : new RegExp('^'+ moment(this.dob).format('YYMMDD')+'[0-9]{4}$') , 'msz' : "10-digit number.The initial six digits correspond to the birth date (YYMMDD).The next three digits designate the birth order number, the third digit being even for males and odd for females. Each district is assigned a range of three-digit numbers, used consecutively, altering even and odd numbers between males and females born on the particular day.The tenth digit is a checksum"}
						},
						"MIFIR": [
							{
								"name": "Personal Number",
								"validation": {'important': false , 'regex' : new RegExp('^'+ moment(this.dob).format('YYMMDD')+'[0-9]{4}$') , 'msz' : "10-digit number.The initial six digits correspond to the birth date (YYMMDD).The next three digits designate the birth order number, the third digit being even for males and odd for females. Each district is assigned a range of three-digit numbers, used consecutively, altering even and odd numbers between males and females born on the particular day.The tenth digit is a checksum"}
							},
							{
								"name": "CONCAT",
								"validation": {'important': false, 'regex' : ''}
							}
						]
					},
					"BN": {
						"country": "Brunei Darussalam ",
						"CRS": {
							"name": "N/A",
							"validation": {'important': false, 'regex' : ''}
						},
						"MIFIR": [
							{
								"name": "National Passport Number",
								"validation": {'important': false, 'regex' : ''}
							}
						]
					},
					"BR": {
						"country": "Brazil ",
						"CRS": {
							"name": "Cadastro de Pessoas Físicas – CPF",
							"validation": {'important': false, 'regex' : ''}
						},
						"MIFIR": [
							{
								"name": "National Passport Number",
								"validation": {'important': false, 'regex' : ''}
							}
						]
					},
					"BM": {
						"country": "Bermuda ",
						"CRS": {
							"name": "N/A",
							"validation": {'important': false, 'regex' : ''}
						},
						"MIFIR": [
							{
								"name": "National Passport Number",
								"validation": {'important': false, 'regex' : ''}
							}
						]
					},
					"BZ": {
						"country": "Belize ",
						"CRS": {
							"name": "TIN",
							"validation": {'important': false, 'regex' : ''}
						},
						"MIFIR": [
							{
								"name": "National Passport Number",
								"validation": {'important': false, 'regex' : ''}
							}
						]
					},
					"BE": {
						"country": "Belgium ",
						"CRS": {
							"name": "Numro National(NN)",
							"validation": {'important': false, 'regex' : ''}
						},
						"MIFIR": [
							{
								"name": "Numro National(NN)",
								"validation": {'important': false, 'regex' : ''}
							},
							{
								"name": "CONCAT",
								"validation": {'important': false, 'regex' : ''}
							}
						]
					},
					"BH": {
						"country": "Bahrain ",
						"CRS": {
							"name": "N/A",
							"validation": {'important': false, 'regex' : ''}
						},
						"MIFIR": [
							{
								"name": "National Passport Number",
								"validation": {'important': false, 'regex' : ''}
							}
						]
					},
					"AZ": {
						"country": "Azerbaijan ",
						"CRS": {
							"name": "VOEN",
							"validation": {'important': false, 'regex' : ''}
						},
						"MIFIR": [
							{
								"name": "National Passport Number",
								"validation": {'important': false, 'regex' : ''}
							}
						]
					},
					"AT": {
						"country": "Austria ",
						"CRS": {
							"name": "Steuernummer",
							"validation": {'important': true , 'regex' : new RegExp('^[0-9]{2}[-]{0,1}[0-9]{3}[/]{0,1}[0-9]{4}$') , 'msz' : "9-digit number.The hyphen and the slash are not mandatory in all cases (e.g. for the purpose of IT processing, they should be omitted)(99-999/9999). "}
						},
						"MIFIR": [
							{
								"name": "CONCAT",
								"validation": {'important': false, 'regex' : ''}
							}
						]
					},
					"AU": {
						"country": "Australia",
						"CRS": {
							"name": "Australian Tax File Number (TFN)",
							"validation": {'important': false, 'regex' : ''}
						},
						"MIFIR": [
							{
								"name": "National Passport Number",
								"validation": {'important': false, 'regex' : ''}
							}
						]
					},
					"AW": {
						"country": "Aruba ",
						"CRS": {
							"name": "Persoonsnummer",
							"validation": {'important': false, 'regex' : ''}
						},
						"MIFIR": [
							{
								"name": "National Passport Number",
								"validation": {'important': false, 'regex' : ''}
							}
						]
					},
					"AR": {
						"country": "Argentina ",
						"CRS": {
							"name": "C.U.I.T. - Clave Unica de Identificacion Tributaria",
							"validation": {'important': false, 'regex' : ''}
						},
						"MIFIR": [
							{
								"name": "National Passport Number",
								"validation": {'important': false, 'regex' : ''}
							}
						]
					},
					"AD": {
						"country": "Andorra ",
						"CRS": {
							"name": "NRT - Numero d'Identificacio Administrativa",
							"validation": {'important': false, 'regex' : ''}
						},
						"MIFIR": [
							{
							"name": "National Passport Number",
							"validation": {'important': false, 'regex' : ''}
							}
						]
					},
                    "AF":{"country":"AF","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"AX":{"country":"AX","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"AL":{"country":"AL","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"DZ":{"country":"DZ","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"AS":{"country":"AS","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"AO":{"country":"AO","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"AI":{"country":"AI","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"AQ":{"country":"AQ","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"AG":{"country":"AG","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"AM":{"country":"AM","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"BD":{"country":"BD","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"BB":{"country":"BB","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"BY":{"country":"BY","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"BJ":{"country":"BJ","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"BT":{"country":"BT","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"BO":{"country":"BO","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"BA":{"country":"BA","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"BW":{"country":"BW","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"BV":{"country":"BV","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"IO":{"country":"IO","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"BF":{"country":"BF","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"BI":{"country":"BI","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"KH":{"country":"KH","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"CM":{"country":"CM","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"CV":{"country":"CV","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"CF":{"country":"CF","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"TD":{"country":"TD","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"CX":{"country":"CX","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"CC":{"country":"CC","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"KM":{"country":"KM","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"CG":{"country":"CG","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"CD":{"country":"CD","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"CI":{"country":"CI","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"CU":{"country":"CU","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"DJ":{"country":"DJ","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"DM":{"country":"DM","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"DO":{"country":"DO","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"TL":{"country":"TL","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"EG":{"country":"EG","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"SV":{"country":"SV","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"GQ":{"country":"GQ","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"ER":{"country":"ER","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"ET":{"country":"ET","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"FK":{"country":"FK","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"FJ":{"country":"FJ","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"GF":{"country":"GF","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"PF":{"country":"PF","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"TF":{"country":"TF","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"GA":{"country":"GA","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"GM":{"country":"GM","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"GH":{"country":"GH","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"GD":{"country":"GD","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"GP":{"country":"GP","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"GU":{"country":"GU","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"GT":{"country":"GT","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"GN":{"country":"GN","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"GW":{"country":"GW","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"GY":{"country":"GY","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"HT":{"country":"HT","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"HM":{"country":"HM","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"HN":{"country":"HN","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"IR":{"country":"IR","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"IQ":{"country":"IQ","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"JM":{"country":"JM","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"JO":{"country":"JO","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"KZ":{"country":"KZ","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"KE":{"country":"KE","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"KI":{"country":"KI","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"KP":{"country":"KP","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"KG":{"country":"KG","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"LA":{"country":"LA","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"LS":{"country":"LS","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"LR":{"country":"LR","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"LY":{"country":"LY","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"MK":{"country":"MK","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"MG":{"country":"MG","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"MW":{"country":"MW","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"MV":{"country":"MV","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"ML":{"country":"ML","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"MQ":{"country":"MQ","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"MR":{"country":"MR","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"YT":{"country":"YT","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"FM":{"country":"FM","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"MD":{"country":"MD","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"MC":{"country":"MC","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"MN":{"country":"MN","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"ME":{"country":"ME","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"MA":{"country":"MA","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"MZ":{"country":"MZ","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"MM":{"country":"MM","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"NA":{"country":"NA","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"NP":{"country":"NP","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"NL":{"country":"NL","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"NC":{"country":"NC","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"NI":{"country":"NI","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"NE":{"country":"NE","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"NG":{"country":"NG","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"NU":{"country":"NU","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"NF":{"country":"NF","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"MP":{"country":"MP","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"OM":{"country":"OM","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"PK":{"country":"PK","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"PW":{"country":"PW","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"PS":{"country":"PS","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"PA":{"country":"PA","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"PG":{"country":"PG","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"PY":{"country":"PY","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"PE":{"country":"PE","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"PH":{"country":"PH","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"PN":{"country":"PN","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"PR":{"country":"PR","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"QA":{"country":"QA","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"RE":{"country":"RE","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"RW":{"country":"RW","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"SH":{"country":"SH","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"KN":{"country":"KN","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"PM":{"country":"PM","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"BL":{"country":"BL","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"MF":{"country":"MF","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"ST":{"country":"ST","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"SN":{"country":"SN","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"RS":{"country":"RS","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"SL":{"country":"SL","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"SB":{"country":"SB","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"SO":{"country":"SO","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"GS":{"country":"GS","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"SS":{"country":"SS","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"LK":{"country":"LK","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"SD":{"country":"SD","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"SR":{"country":"SR","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"SJ":{"country":"SJ","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"SZ":{"country":"SZ","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"SY":{"country":"SY","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"TW":{"country":"TW","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"TJ":{"country":"TJ","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"TZ":{"country":"TZ","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"TH":{"country":"TH","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"TG":{"country":"TG","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"TK":{"country":"TK","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"TO":{"country":"TO","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"TN":{"country":"TN","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"TM":{"country":"TM","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"TV":{"country":"TV","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"UG":{"country":"UG","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"UA":{"country":"UA","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"UM":{"country":"UM","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"UZ":{"country":"UZ","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"VU":{"country":"VU","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"VA":{"country":"VA","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"VE":{"country":"VE","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"VN":{"country":"VN","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"VG":{"country":"VG","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"VI":{"country":"VI","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"WF":{"country":"WF","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"EH":{"country":"EH","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"YE":{"country":"YE","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"ZM":{"country":"ZM","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]},"ZW":{"country":"ZW","CRS":{"name":"TIN","validation": {'important': true , 'regex' : ''}},"MIFIR":[{"name":"National Passport Number","validation": {'important': false, 'regex' : ''}},{"name":"CONCAT","validation": {'important': false, 'regex' : ''}}]}
                    
				}
			}
        },
        components: {
            datepicker : Datepicker
        },
        created(){ 
			this.$trackEvent('CP+Client+Verification+1+Pageview');
            if(parseInt(this.get_user.profile.ipv_status)){
                // this.disable = true;
            }
            this._runGetUserRegisterationStepData({'globalParams' :{},'localParams' :{ "parameter" : this , "step" : '1'}})
            this.datePickerFunc();
			this.residence_country = this.RemoveNode('US')
        },
		mounted() { 
            const _that = this
            $(document).on("click", function(event){
                if(!$(event.target).closest('.tabClass').length){
                    _that.tabActive = ''
                }
            });
			const countryList = this.$refs.countryList.$refs.search;
            countryList.addEventListener('focus', () => {
                this.$trackEvent('CP+Client+Verification+1+Country'); 
            });
			const res_nationalityInput = this.$refs.res_nationalityInput.$refs.search;
            res_nationalityInput.addEventListener('focus', () => {
                this.$trackEvent('CP+Client+Verification+1+Nationality'); 
            });
        },
    }
</script>
<style>
    /* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
.tooltip .tooltiptext p {
	text-align: left !important;
	margin-bottom: 5px;
}
.tooltiptext ol {
	margin: 15px 0 15px 0;
    padding: 4px;
}
.tooltiptext ol li {
	list-style-type: upper-roman;
    margin-left: 31px;
    text-align: left;
    line-height: 22px;
}
.tooltiptext ul li {
    margin-left: 31px;
    text-align: left;
    line-height: 22px;
}
.tooltiptext ul {
    padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/fxView/registerSteps/step1.vue